'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = require('react-event-listener');

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _overlay = require('../overlay');

var _overlay2 = _interopRequireDefault(_overlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var displayName = 'Menu';

var propTypes = {
  /** The Menu's content (MenuItem) */
  children: _propTypes2.default.node.isRequired,
  /** Menu open */
  open: _propTypes2.default.bool,
  /**
   * Callback fired when Menu's overlay or MenuItems are clicked
   *
   * function(event: object) => void
   */
  closeMenu: _propTypes2.default.func,
  /** The Menu's header */
  header: _propTypes2.default.node,
  /** The header's icon */
  headerIcon: _propTypes2.default.node,
  /** The Menu's footer */
  footer: _propTypes2.default.node,
  /** The Menu's footer */
  position: _propTypes2.default.oneOf(['left', 'right']),
  /** Override the styles of the icon element */
  iconStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the header element */
  headerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the footer element */
  footerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the footer element */
  contentContainerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  color: _propTypes2.default.string.isRequired
};

var defaultProps = {
  open: false,
  closeMenu: null,
  header: null,
  footer: null,
  position: 'left',
  style: {},
  headerStyle: {},
  headerIcon: null,
  iconStyle: {},
  footerStyle: {},
  contentContainerStyle: {}
};

/** Menu that slides in from the left or right */

var Menu = function (_Component) {
  _inherits(Menu, _Component);

  function Menu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeyUp = function (event) {
      var closeMenu = _this.props.closeMenu;


      if (event.which === 27) {
        closeMenu(event);
      }
    }, _this.renderNav = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          open = _this$props.open,
          header = _this$props.header,
          footer = _this$props.footer,
          position = _this$props.position,
          headerIcon = _this$props.headerIcon,
          closeMenu = _this$props.closeMenu,
          style = _this$props.style,
          iconStyle = _this$props.iconStyle,
          headerStyle = _this$props.headerStyle,
          footerStyle = _this$props.footerStyle,
          contentContainerStyle = _this$props.contentContainerStyle,
          color = _this$props.color,
          custom = _objectWithoutProperties(_this$props, ['children', 'open', 'header', 'footer', 'position', 'headerIcon', 'closeMenu', 'style', 'iconStyle', 'headerStyle', 'footerStyle', 'contentContainerStyle', 'color']);

      var menuItems = _react2.default.Children.map(children, function (child) {
        if (!child) {
          return null;
        }

        return (0, _react.cloneElement)(child, { closeMenu: closeMenu });
      });

      var rootStyle = _getStyles2.default.root(open, position, style);

      if (!closeMenu) {
        rootStyle = _getStyles2.default.sidebar(style);
      }

      return _react2.default.createElement(
        'nav',
        _extends({ style: rootStyle }, custom),
        headerIcon ? _react2.default.createElement(
          'div',
          { style: _getStyles2.default.icon(iconStyle) },
          _react2.default.cloneElement(headerIcon, { color: color })
        ) : null,
        header ? _react2.default.createElement(
          'h1',
          { style: _getStyles2.default.header(color, headerIcon, headerStyle) },
          header
        ) : null,
        _react2.default.createElement(
          'section',
          { style: _getStyles2.default.contentContainer(header, footer, contentContainerStyle) },
          menuItems,
          footer ? _react2.default.createElement(
            'span',
            { style: _getStyles2.default.footer(!closeMenu, footerStyle) },
            footer
          ) : null
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Menu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          open = _props.open,
          closeMenu = _props.closeMenu;


      if (!closeMenu) {
        return this.renderNav();
      }

      return _react2.default.createElement(
        'section',
        { style: _getStyles2.default.container() },
        _react2.default.createElement(_overlay2.default, { style: _getStyles2.default.overlay(open), onClick: closeMenu }),
        this.renderNav(),
        open ? _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }) : null
      );
    }
  }]);

  return Menu;
}(_react.Component);

Menu.displayName = displayName;
Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;

exports.default = Menu;
module.exports = exports.default;